var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"text-primary overflow-auto"},[_vm._v(" Experience ")]),_c('ul',{staticClass:"mb-5 timeline"},_vm._l((_vm.experiences),function(entry){return _c('experience-entry',{key:entry.id,attrs:{"entry":entry}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }